import { render, staticRenderFns } from "./RemnantAdmin.vue?vue&type=template&id=45821c2f"
import script from "./RemnantAdmin.vue?vue&type=script&lang=js"
export * from "./RemnantAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports